import React, { useState, useEffect } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import axios from 'axios';
import { toast } from 'react-toastify';

const RisingStarEdit = () => {
  const users = {
    discount: "",
    product:"",
    current_price:"",
    old_price:"",
  };

  const [RisingStartEditUser, setRisingStartEditUser] = useState(users);
  const [RisingStartImage, setRisingStartImage] = useState(null);
  const [RisingStartLogo, setRisingStartLogo] = useState(null);
  const [previewImage, setPreviewImage] = useState(null);
  const [previewLogo, setPreviewLogo] = useState(null);
  const { id } = useParams();
  
  const navigate = useNavigate();
  console.log("Sending ID to API:", id);

  useEffect(() => {
  const fetchPedagogyData = async () => {
    try {
      const response = await axios.post(
        "https://cyberathon.com/multivendor/index.php/Api/Master_controller/get_rising_star_by_id",
        JSON.stringify({ id }),
        {
          headers: { "Content-Type": "application/json" },
        }
      );

      console.log("Fetched response:", response.data); // Debug

      if (response.data?.status === "true" && response.data?.result) {
        const result = response.data.result;
        setRisingStartEditUser(result);

        // ✅ Set preview images
        if (result.rising_star_image) {
          setPreviewImage(`https://cyberathon.com/multivendor/${result.rising_star_image}`);
        }
        if (result.brand_logo) {
          setPreviewLogo(`https://cyberathon.com/multivendor/${result.brand_logo}`);
        }
      } else {
        console.error("Invalid response structure:", response.data);
      }
    } catch (error) {
      console.error("Error fetching Top Deals data!", error);
    }
  };

  fetchPedagogyData();
}, [id]);




  // ✅ Handle text changes
  const changeHandler = (e) => {
    const { name, value } = e.target;
    setRisingStartEditUser({ ...RisingStartEditUser, [name]: value });
  };

  // ✅ Handle file uploads
  const handleFileChange = (e, type) => {
    const file = e.target.files[0];
    if (!file) return;

    if (type === "rising_star_image") {
      setRisingStartImage(file);
      setPreviewImage(URL.createObjectURL(file));
    } else if (type === "brand_logo") {
      setRisingStartLogo(file);
      setPreviewLogo(URL.createObjectURL(file));
    }
  };

  // ✅ Handle form submit
  const submitForm = async (e) => {
  e.preventDefault();

  const formData = new FormData();
  formData.append("id", id);
  formData.append("discount", RisingStartEditUser.discount);
  formData.append("product", RisingStartEditUser.product);
  formData.append("current_price", RisingStartEditUser.current_price);
  formData.append("old_price", RisingStartEditUser.old_price);

  // ✅ If new image uploaded, append file; otherwise, keep old path
  if (RisingStartImage) {
    formData.append("rising_star_image", RisingStartImage);
  } else {
    formData.append("rising_star_image", RisingStartEditUser.rising_star_image);
  }

  if (RisingStartLogo) {
    formData.append("brand_logo", RisingStartLogo);
  } else {
    formData.append("brand_logo", RisingStartEditUser.brand_logo);
  }

  try {
    const response = await axios.post(
      "https://cyberathon.com/multivendor/index.php/Api/Master_controller/rising_star_update",
      formData,
      { headers: { "Content-Type": "multipart/form-data" } }
    );

    if (response.data?.status === "true") {
      toast.success(response.data.message || "Top Deals updated successfully");
      navigate("/RisingStart-list", { replace: true });
      window.location.reload(); // ✅ ensures list refetches updated data
    } else {
      toast.error(response.data.message || "Failed to update Top Deals");
    }
  } catch (error) {
    console.error("There was an error!", error);
  }
};


  return (
    <div className="page-content">
      <div className="container-fluid">
        <div className="page-title-box">
          <h4 className="mb-0 fw-semibold">Edit Top Deals</h4>
          <ol className="breadcrumb mb-0">
            <li className="breadcrumb-item"><a href="#">Top Deals</a></li>
            <li className="breadcrumb-item active">Edit</li>
          </ol>
        </div>

        <form onSubmit={submitForm}>
          <div className="card">
            <div className="card-header">
              <h4 className="card-title">Edit Top Deals</h4>
            </div>
            <div className="card-body row">
              
              <div className="col-lg-6 mb-3">
  <label className="form-label">Main Image</label>
  <input
    type="file"
    className="form-control"
    onChange={(e) => handleFileChange(e, 'rising_star_image')}
  />
  {previewImage && (
    <img
      src={previewImage}
      alt="Preview"
      height="80"
      className="mt-2 border rounded"
    />
  )}
</div>

<div className="col-lg-6 mb-3">
  <label className="form-label">Brand Logo</label>
  <input
    type="file"
    className="form-control"
    onChange={(e) => handleFileChange(e, 'brand_logo')}
  />
  {previewLogo && (
    <img
      src={previewLogo}
      alt="Logo"
      height="80"
      className="mt-2 border rounded"
    />
  )}
</div>

<div className="col-lg-6 mb-3">
  <label className="form-label">Product Name</label>
  <input
    type="text"
    name="product"
    value={RisingStartEditUser?.product || ""}
    onChange={changeHandler}
    className="form-control"
    placeholder="Enter Product Name"
  />
</div>

<div className="col-lg-6 mb-3">
  <label className="form-label">Current Price</label>
  <input
    type="text"
    name="current_price"
    value={RisingStartEditUser?.current_price || ""}
    onChange={changeHandler}
    className="form-control"
    placeholder="Current Price"
  />
</div>

<div className="col-lg-6 mb-3">
  <label className="form-label">Old Price</label>
  <input
    type="text"
    name="old_price"
    value={RisingStartEditUser?.old_price || ""}
    onChange={changeHandler}
    className="form-control"
    placeholder="Old Price"
  />
</div>

<div className="col-lg-6 mb-3">
  <label className="form-label">Discount</label>
  <input
    type="text"
    name="discount"
    value={RisingStartEditUser?.discount || ""}
    onChange={changeHandler}
    className="form-control"
    placeholder="e.g., 30–60% Off"
  />
</div>
            </div>
            <div className="card-footer">
              <button type="submit" className="btn btn-primary">
                Update Top Deals
              </button>
            </div>
          </div>
        </form>
      </div>
    </div>
  );
};

export default RisingStarEdit;
